import React from 'react';
import { FormRadio, Type, spacer16 } from '@spotify-internal/encore-web';

// import { useTranslation } from 'providers/translations/TranslationProvider';

import { ReasonKey } from '../../hooks/useSubmitReason';

interface Reason {
  key: ReasonKey;
  title: string;
}

interface ReasonSelectorProps {
  selected?: ReasonKey;
  onSelect: (value: ReasonKey) => void;
}

const ReasonSelector = ({ selected, onSelect }: ReasonSelectorProps) => {
  // const { t } = useTranslation();

  const reasons: Reason[] = [
    {
      key: 'no-looking-for',
      title: "It didn't address what I was searching for", // t('feedback_reason_no_looking_for'),
    },
    {
      key: 'no-resolved',
      title: "It didn't resolve my issue", // t('feedback_reason_no_resolved'),
    },
    {
      key: 'confusing',
      title: 'It was confusing', // t('feedback_reason_confusing'),
    },
    {
      key: 'other',
      title: 'Other', // t('feedback_reason_other'),
    },
  ];

  return (
    <div role="group" aria-labelledby="reason-selector_label" aria-live="polite">
      <Type id="reason-selector_label" as="p" variant="ballad" paddingBottom={spacer16}>
        {/* {t('feedback_why_is_not_helpful')}*/}
        Before we connect you with our messaging team, tell us why the article wasn't helpful:
      </Type>
      {reasons.map(reason => (
        <FormRadio
          key={reason.key}
          id={`reason-selector_${reason.key}`}
          data-testid={`reason-selector_${reason.key}`}
          name="reason-selector"
          checked={selected === reason.key}
          onChange={() => onSelect(reason.key)}
        >
          {reason.title}
        </FormRadio>
      ))}
    </div>
  );
};

export default ReasonSelector;
